import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, iconColor, actionLabel, actionPath }) => {
  const navigate = useNavigate();

  const handleAction = () => {
    navigate(actionPath);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 transition-all duration-250 hover:shadow-subtle">
      <div className="flex items-start gap-4 mb-4">
        <div 
          className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ background: `${iconColor}15` }}
        >
          <Icon name={icon} size={20} color={iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground line-clamp-2">{description}</p>
        </div>
      </div>
      <Button 
        variant="outline" 
        fullWidth 
        onClick={handleAction}
        iconName="ArrowRight"
        iconPosition="right"
      >
        {actionLabel}
      </Button>
    </div>
  );
};

export default QuickActionCard;